const r = (o, t) => {
  let e;
  return function(...c) {
    const s = () => {
      clearTimeout(e), o(...c);
    };
    clearTimeout(e), e = setTimeout(s, t);
  };
}, n = typeof process == "object" && process && process.env && process.env.UNIT_TESTING_ENV;
export {
  r,
  n as u
};
